import React, { useState } from "react";
import {
	LoadingButton,
	ToastAlertSuccess,
	ToastAlertError,
} from "../../../reauseble";
import { ToastContainer } from "react-toastify";
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faEnvelope, faLocationDot, faPhone, faCircleDot, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import axios from "axios";

// Sanitize user input to prevent XSS attacks
const sanitizeInput = (input) => {
	if (typeof input !== 'string') return input;
	return input
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#x27;')
		.replace(/\//g, '&#x2F;');
};

const Contactsec1 = () => {
	const [contactDetails, setContactDetails] = useState({
		first_name: "",
		last_name: "",
		email: "",
		phone: "",
		message: "",
	});
	const [loading, setLoading] = useState(false);


	const handleContact = (e) => {
		e.preventDefault();
		const { first_name, email, last_name, message, phone } = contactDetails;

		if (first_name && email && last_name && message && phone) {
			if (String(email)
				.toLowerCase()
				.match(
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				)) {


				setLoading(true);
				// Sanitize all user inputs before sending to prevent stored XSS
				const sanitizedData = {
					first_name: sanitizeInput(contactDetails.first_name),
					last_name: sanitizeInput(contactDetails.last_name),
					email: sanitizeInput(contactDetails.email),
					phone: sanitizeInput(contactDetails.phone),
					message: sanitizeInput(contactDetails.message),
				};
				CoreHttpHandler.request(
					"forms",
					"contact",
					{
						...sanitizedData,
					},
					(response) => {
						setLoading(false);
						ToastAlertSuccess("Successfuly submitted");
						setContactDetails({
							first_name: "",
							last_name: "",
							email: "",
							phone: "",
							message: "",
						})
					},
					(err) => {
						ToastAlertError(
							err?.response?.data?.message
								? err?.response.data.message
								: "something went wrong"
						);
						setLoading(false);
					}
				);
				// const headers = {
				// 	'Content-Type': 'application/json',
				// 	'authKey': 'vix4gjnSDp3t2AcCuQo40VIjVIWyVvt1'
				// }
				// axios.post('http://10.1.145.182:5004/CDSWebServices/sendEmail/cdc/sendeAlert', {
				// 	userId: "EGOV",
				// 	emailSubject: "Sample Email Subject",
				// 	emailText: message,
				// 	emailAddress: email
				// }, {
				// 	headers: headers
				// })
				// 	.then(function (response) {
				// 		console.log(response);
				// 		setLoading(false);
				// 		ToastAlertSuccess("Successfuly submitted");
				// 		setContactDetails({
				// 			first_name: "",
				// 			last_name: "",
				// 			email: "",
				// 			phone: "",
				// 			message: "",
				// 		})

				// 	})
				// 	.catch(function (error) {
				// 		console.log(error);
				// 	});
			} else {
				ToastAlertError("Invalid Email!");

			}
		} else {
			setLoading(false);
			ToastAlertError("Please fill all fields");
		}
	};
	return (
		<>

			<section className='sec sec10'>
				<div className='container flex_btw'>
					<div>
						<h1 className="bold">Get in Touch</h1>
						{/* <h6>For any inquiries or additional support, please visit our contact page. We are here to assist you with any questions or concerns related to your experience on E Governance Online.</h6> */}


						<h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faCircleDot} />
								<span>
									For feedback and queries related to courses, trainings & Faqs, PICG to be contacted
								</span>
							</div>
						</h5>
						{/* <h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faCircleDot} />
								<span>
									For any technical support CDC to be contacted.
								</span>
							</div>
						</h5> */}
						<h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faLocationDot} />
								<span>
									Suite # 316, The Forum Khayaban-e-Jami,Block-9, Clifton, Karachi - 75600.
								</span>
							</div>
						</h5>
						<h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faEnvelope} />
								<span>
									<address>
										<a href="mailto:governance@picg.org.pk">governance@picg.org.pk</a>

									</address>
									{/* governance@picg.org.pk */}
								</span>
							</div>
						</h5>
						<h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faPhone} />
								<span>
									+92 (21) 35306673
									+92 (21) 35306674
								</span>
							</div>

						</h5>
						<h5 className="bold">
							<div className="icon-text-wrapper">
								<FontAwesomeIcon className="icon" icon={faClock} />
								<span>
									Monday to Friday: 9 am to 5 pm (Closed on Saturday & Sunday)
								</span>
							</div>
						</h5>
					</div>
					<div className="inputs" style={{ marginBottom: "20px" }}>
						<h2>Feedback</h2>


						<Input value={contactDetails.first_name}
							required
							onChange={(e) =>
								setContactDetails({
									...contactDetails,
									first_name: e.target.value,
								})
							}
							placeholder="First Name"
						/>

						<Input value={contactDetails.last_name}
							required
							onChange={(e) =>
								setContactDetails({
									...contactDetails,
									last_name: e.target.value,
								})
							}
							placeholder="Last Name"
						/>

						<Input value={contactDetails.email}
							required
							onChange={(e) =>
								setContactDetails({
									...contactDetails,
									email: e.target.value,
								})
							}
							type="email"
							placeholder="Email"
						/>

						<Input value={contactDetails.phone}
							required
							onChange={(e) =>
								setContactDetails({
									...contactDetails,
									phone: e.target.value,
								})
							}
							type="tel"
							placeholder="Phone"
						/>

						<TextArea value={contactDetails.message}
							required
							onChange={(e) =>
								setContactDetails({
									...contactDetails,
									message: e.target.value,
								})
							}
							rows={5}
							placeholder="Write your message"
						/>

						 <button onClick={handleContact} className="rounded_btn" disabled={loading}>Submit</button>

					</div>
				</div>
			</section >

		</>
	);
};

export default Contactsec1;
